/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser"

const adName = process.env.REACT_APP_AD_NAME || "brunodevelopment"
const adClientId = process.env.REACT_APP_AD_CLIENT_ID || "c3fce4be-26b1-40c1-94df-bda71d2b17a9"

const b2cScopes = [`https://${adName}.onmicrosoft.com/${adClientId}/user.read`]

export const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1_signin",
        editProfile: "B2C_1_editprofile"
    },
    authorities: {
        signUpSignIn: {
            authority: `https://${adName}.b2clogin.com/${adName}.onmicrosoft.com/B2C_1_signin`
        },
        editProfile: {
            authority: `https://${adName}.b2clogin.com/${adName}.onmicrosoft.com/B2C_1_editprofile`
        }
    },
    authorityDomain: `${adName}.b2clogin.com`
}

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
 const frontEndUrl = process.env.REACT_APP_PUBLIC_URL || "http://localhost:8080"

export const msalConfig = {
    auth: {
        clientId: adClientId, // This is the ONLY mandatory field; everything else is optional.
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose sign-up/sign-in user-flow as your default.
        knownAuthorities: [b2cPolicies.authorityDomain], // You must identify your tenant's domain as a known authority.
        redirectUri: `${frontEndUrl}/postlogin`, // You must register this URI on Azure Portal/App Registration. Defaults to "window.location.href".
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message)
                        return
                    case LogLevel.Info:
                        console.info(message)
                        return
                    case LogLevel.Verbose:
                        console.debug(message)
                        return
                    case LogLevel.Warning:
                        console.warn(message)
                }
            }
        }
    }
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["openid", ...b2cScopes]
}

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com"
}

export const tokenRequest = {
    scopes: [...b2cScopes],  // e.g. ["https://fabrikamb2c.onmicrosoft.com/helloapi/demo.read"]
    forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
}